import React, { memo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useOnclickOutside from "react-cool-onclickoutside";
import styled from "styled-components";
import BibleHistoryItem from "./bible_history_item";
import { useBiblePageContext } from "../../../../bible_page_context";

const BibleHistoryBlockWrapper = styled.div`
  position: absolute;
  top: 36px;
  left: 0;
  width: 100%;
  max-height: calc(100vh - 200px); /* адаптивный предел */
  border-radius: 15px;
  background: #fff;
  box-shadow: 4.462px 4.462px 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 10;
`;

const BibleHistoryBlockScrollArea = styled.div`
  overflow-y: auto;
  max-height: inherit;
`;

const BibleHistoryBlockContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 10px 8px;
`;

const BibleHistoryBlock = ({
  bibleTranslations,
  historyButtonRef,
  toggleOpenBibleHistory,
}) => {
  const navigate = useNavigate();
  const historyBlockRef = useRef(null);

  const { bibleHistory } = useBiblePageContext();

  useOnclickOutside(() => toggleOpenBibleHistory(), {
    refs: [historyBlockRef, historyButtonRef],
  });

  const handleHistoryItemClick = (item) => {
    const url = `/bible/?bibleId=${item.b}&bookId=${item.bk}&chapterId=${item.ch}`;
    navigate(url);
    toggleOpenBibleHistory();
  };

  return (
    <BibleHistoryBlockWrapper>
      <BibleHistoryBlockScrollArea>
        <BibleHistoryBlockContent ref={historyBlockRef}>
          {!!bibleHistory?.length &&
            bibleHistory.map((historyItem, index) => (
              <BibleHistoryItem
                key={index + historyItem.b + historyItem.bk + historyItem.ch}
                historyItem={historyItem}
                bibleTranslations={bibleTranslations}
                handleHistoryItemClick={handleHistoryItemClick}
              />
            ))}
        </BibleHistoryBlockContent>
      </BibleHistoryBlockScrollArea>
    </BibleHistoryBlockWrapper>
  );
};

export default memo(BibleHistoryBlock);
